<div class="container py-4">
  <!-- Toast Notification -->
  <div
    *ngIf="showToast"
    class="position-fixed top-0 start-50 translate-middle-x mt-3"
    style="z-index: 9999"
  >
    <div
      class="alert alert-dismissible fade show shadow-lg"
      [ngClass]="{
        'alert-success': toastType === 'success',
        'alert-danger': toastType === 'error'
      }"
      role="alert"
    >
      <i
        class="me-2"
        [class.bi-check-circle-fill]="toastType === 'success'"
        [class.bi-exclamation-circle-fill]="toastType === 'error'"
      ></i>
      {{ toastMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="closeToast()"
        aria-label="Close"
      ></button>
    </div>
  </div>

  <!-- Header -->
  <div class="card bg-linear-gradient-purple text-white mb-4">
    <div class="card-body py-4">
      <h2 class="mb-1"><i class="bi bi-shield-lock me-2"></i>Admin Panel</h2>
      <p class="mb-0 opacity-75">
        Manage brands, organizations, and system administrators
      </p>
      <small class="badge bg-light text-dark mt-2">
        Current Org: {{ orgName || "Loading..." }}
      </small>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-white">
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
          <button
            class="nav-link"
            [class.active]="activeTab === 'brands'"
            (click)="setActiveTab('brands')"
          >
            <i class="bi bi-tags me-2"></i>Brands
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            [class.active]="activeTab === 'orgs'"
            (click)="setActiveTab('orgs')"
          >
            <i class="bi bi-building me-2"></i>Organizations
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            [class.active]="activeTab === 'managers'"
            (click)="setActiveTab('managers')"
          >
            <i class="bi bi-person-badge me-2"></i>Managers
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            [class.active]="activeTab === 'switch'"
            (click)="setActiveTab('switch')"
          >
            <i class="bi bi-arrow-left-right me-2"></i>Switch Org
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            [class.active]="activeTab === 'logins'"
            (click)="setActiveTab('logins'); loadLoginHistory()"
          >
            <i class="bi bi-clock-history me-2"></i>Login History
          </button>
        </li>
      </ul>
    </div>

    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-muted">Loading data...</p>
      </div>

      <!-- Brands Tab -->
      <div *ngIf="activeTab === 'brands' && !loading">
        <h5 class="mb-3">
          <i class="bi bi-tags me-2 text-primary"></i>Create New Brand
        </h5>
        <form [formGroup]="brandForm" (ngSubmit)="createBrand()">
          <div class="row g-3 mb-4">
            <div class="col-md-8">
              <label class="form-label fw-semibold">Brand Name</label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                placeholder="e.g., Plato's Closet"
              />
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Active</label>
              <select class="form-select" formControlName="active">
                <option [value]="true">Yes</option>
                <option [value]="false">No</option>
              </select>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="saving || brandForm.invalid"
          >
            <i class="bi bi-plus-circle me-2"></i>
            {{ saving ? "Creating..." : "Create Brand" }}
          </button>
        </form>

        <hr class="my-4" />

        <h5 class="mb-3">Existing Brands</h5>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
              <tr>
                <th>Name</th>
                <th>Active</th>
                <th>ID</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let brand of brands">
                <td>{{ brand.name }}</td>
                <td>
                  <span
                    class="badge"
                    [class.bg-success]="brand.active"
                    [class.bg-secondary]="!brand.active"
                  >
                    {{ brand.active ? "Active" : "Inactive" }}
                  </span>
                </td>
                <td>
                  <code class="small">{{ brand.id }}</code>
                </td>
              </tr>
              <tr *ngIf="brands.length === 0">
                <td colspan="3" class="text-center text-muted">
                  No brands found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Organizations Tab -->
      <div *ngIf="activeTab === 'orgs' && !loading">
        <h5 class="mb-3">
          <i class="bi bi-building me-2 text-primary"></i>Create New
          Organization
        </h5>
        <form [formGroup]="orgForm" (ngSubmit)="createOrganization()">
          <div class="row g-3 mb-4">
            <div class="col-md-6">
              <label class="form-label fw-semibold">Organization Name</label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                placeholder="e.g., Plato's Closet"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Brand</label>
              <select class="form-select" formControlName="brandId">
                <option value="">Select a brand</option>
                <option *ngFor="let brand of brands" [value]="brand.id">
                  {{ brand.name }}
                </option>
              </select>
            </div>
            <div class="col-md-8">
              <label class="form-label fw-semibold">Location</label>
              <input
                type="text"
                class="form-control"
                formControlName="location"
                placeholder="e.g., 17937 Interstate 45 #127, Shenandoah, TX 77385"
              />
            </div>
            <div class="col-md-4">
              <label class="form-label fw-semibold">Active</label>
              <select class="form-select" formControlName="active">
                <option [value]="true">Yes</option>
                <option [value]="false">No</option>
              </select>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="saving || orgForm.invalid"
          >
            <i class="bi bi-plus-circle me-2"></i>
            {{ saving ? "Creating..." : "Create Organization" }}
          </button>
        </form>

        <hr class="my-4" />

        <h5 class="mb-3">Existing Organizations</h5>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
              <tr>
                <th>Name</th>
                <th>Brand</th>
                <th>Location</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let org of organizations">
                <td>{{ org.name }}</td>
                <td>{{ getBrandName(org.brandId) }}</td>
                <td>
                  <small class="text-muted">{{ org.location }}</small>
                </td>
                <td>
                  <span
                    class="badge"
                    [class.bg-success]="org.active"
                    [class.bg-secondary]="!org.active"
                  >
                    {{ org.active ? "Active" : "Inactive" }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="organizations.length === 0">
                <td colspan="4" class="text-center text-muted">
                  No organizations found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Managers Tab -->
      <div *ngIf="activeTab === 'managers' && !loading">
        <div
          class="alert alert-info d-flex justify-content-between align-items-center mb-4"
        >
          <div>
            <i class="bi bi-calendar-x me-2"></i>
            <strong>Cleanup Tool:</strong> Remove past requested-off dates from
            all employees
          </div>
          <button
            type="button"
            class="btn btn-warning btn-sm"
            (click)="cleanupRequestedOff()"
            [disabled]="cleaningUp"
          >
            <i class="bi bi-trash3 me-2"></i>
            {{ cleaningUp ? "Cleaning..." : "Clean Up Requests" }}
          </button>
        </div>

        <h5 class="mb-3">
          <i class="bi bi-person-badge me-2 text-primary"></i>Create New Manager
        </h5>
        <form [formGroup]="managerForm" (ngSubmit)="createManager()">
          <div class="row g-3 mb-4">
            <div class="col-md-6">
              <label class="form-label fw-semibold">First Name</label>
              <input
                type="text"
                class="form-control"
                formControlName="firstName"
                placeholder="John"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Last Name</label>
              <input
                type="text"
                class="form-control"
                formControlName="lastName"
                placeholder="Doe"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Email</label>
              <input
                type="email"
                class="form-control"
                formControlName="email"
                placeholder="john.doe@example.com"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Organization</label>
              <select class="form-select" formControlName="orgId">
                <option value="">Select an organization</option>
                <option *ngFor="let org of organizations" [value]="org.id">
                  {{ org.name }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Password</label>
              <input
                type="password"
                class="form-control"
                formControlName="password"
                placeholder="Minimum 6 characters"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">PIN (4-6 digits)</label>
              <input
                type="text"
                class="form-control"
                formControlName="pin"
                placeholder="1234"
                maxlength="6"
              />
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="saving || managerForm.invalid"
          >
            <i class="bi bi-plus-circle me-2"></i>
            {{ saving ? "Creating..." : "Create Manager" }}
          </button>
        </form>
      </div>

      <!-- Switch Organization Tab -->
      <div *ngIf="activeTab === 'switch' && !loading">
        <h5 class="mb-3">
          <i class="bi bi-arrow-left-right me-2 text-primary"></i>Switch Active
          Organization
        </h5>
        <p class="text-muted">
          Change which organization you're currently managing as admin.
        </p>
        <div class="row g-3 mb-4">
          <div class="col-md-8">
            <label class="form-label fw-semibold">Select Organization</label>
            <select class="form-select" [(ngModel)]="selectedOrgId">
              <option value="">Choose an organization</option>
              <option *ngFor="let org of organizations" [value]="org.id">
                {{ org.name }} - {{ org.location }}
              </option>
            </select>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-primary"
          (click)="switchOrganization()"
          [disabled]="saving || !selectedOrgId"
        >
          <i class="bi bi-arrow-repeat me-2"></i>
          {{ saving ? "Switching..." : "Switch Organization" }}
        </button>
      </div>

      <!-- Login History Tab -->
      <div *ngIf="activeTab === 'logins' && !loading">
        <h5 class="mb-3">
          <i class="bi bi-clock-history me-2 text-primary"></i>Recent Login
          Activity
        </h5>
        <p class="text-muted">
          View all recorded user login events across organizations.
        </p>

        <div class="table-responsive shadow-sm rounded">
          <table class="table table-hover align-middle">
            <thead class="table-light">
              <tr>
                <th>User</th>
                <th>Organization</th>
                <th>Device</th>
                <th>Date / Time</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let log of loginHistory">
                <td>
                  <i class="bi bi-person-circle text-primary me-2"></i>
                  {{ log.userName || "Unknown" }}
                </td>
                <td>
                  <span class="badge bg-secondary">{{ log.orgId }}</span>
                </td>
                <td>
                  <small
                    class="text-muted d-inline-block text-truncate"
                    style="max-width: 250px"
                  >
                    {{ log.device }}
                  </small>
                </td>
                <td>
                  <small>{{ log.readableTime }}</small>
                </td>
              </tr>
              <tr *ngIf="loginHistory.length === 0">
                <td colspan="4" class="text-center text-muted py-4">
                  <i class="bi bi-info-circle me-1"></i>No login history
                  available
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="text-center mt-3" *ngIf="lastLoginDoc">
          <button
            class="btn btn-outline-primary btn-sm px-4"
            (click)="loadMoreLoginHistory()"
            [disabled]="loadingMore"
          >
            <i class="bi bi-arrow-down-circle me-1"></i>
            {{ loadingMore ? "Loading..." : "Load More" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
